import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../styles/themeColors';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  container: {
    width: '100vw',
    height: stylesConstants.headerHeight,
    backgroundColor: themeColors.primary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: theme.shadows[1],
  },
  dropdown: {
    margin: theme.spacing(2),
    marginRight: theme.spacing(8),
    color: themeColors.textSecondary,
  },
  icon: {
    color: themeColors.textSecondary,
  },
  dropdownContent: {
    position: 'absolute',
    top: '100%',
    backgroundColor: themeColors.secondary,
    width: '100%',
    display: 'block',
    boxShadow: theme.shadows[1],
    zIndex: 10,
    elevation: 10,
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
  },
  dropdownLinks: {
    textDecoration: 'none',
    color: themeColors.textPrimary,
    textTransform: 'none',
    fontSize: 14,
  },
  dropdownItem: {
    padding: theme.spacing(2),
    '&:hover': {
      background: themeColors.selectedBg,
      cursor: 'pointer',
    },
  },
  separatorLine: {
    width: '100%',
    height: 1,
    backgroundColor: themeColors.borders,
  },
  rbIcon: {
    width: stylesConstants.redbullIconWidth,
    margin: theme.spacing(2),
  },
  rbIconMargin: {
    margin: `auto ${theme.spacing(4)}px`,
  },
}));
